export default __webpack_public_path__ + "static/media/@julianelimamancini.33e43e28.jpg";